//main
import ContentFormatXW from "../content/webc/content-format-xw";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import UserViewHeadModule from "../content/users/user-view-head";
import UserViewCredsModule from "../content/users/user-view-creds";


export default function UsersView() {

  return (
  <>
    <ContentFormatXW 
      head='Users'
      link={`/home`}
      form= 'full'
      data= {
        <>
          <UserViewHeadModule />
          <WebbDividerSmall />
          <WebbDividerSmall />
          <UserViewCredsModule />
        </>
      } 
    />
  </>
  )
}